'use client';

import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import cn from './style.module.scss';
interface CustomContainerProps {
  children: React.ReactNode;
  maxWidth?: ResponsiveStyleValue<string | number>;
  flexGrow?: number;
  className?: string;
  paddingInline?: ResponsiveStyleValue<string | number>;
}
const addImportant = (value: ResponsiveStyleValue<string | number>) => {
  if (value === undefined) return value;
  if (typeof value === 'object' && !Array.isArray(value)) {
    const result: Record<string, string> = {};
    Object.keys(value).forEach((key) => {
      result[key] = `${(value as any)[key]} !important`;
    });
    return result;
  }
  return `${value} !important`;
};

export default function CommonContainer({
  children,
  maxWidth,
  flexGrow,
  className = '',
  paddingInline,
}: CustomContainerProps) {
  const responsiveStyles: SxProps<Theme> = {
    ...(maxWidth !== undefined && { maxWidth }),
    ...(flexGrow !== undefined && { flexGrow }),
    ...(paddingInline !== undefined && {
      paddingLeft: addImportant(paddingInline),
      paddingRight: addImportant(paddingInline),
    }),
  };

  return (
    <Box className={`${cn.commonContainer} ${className}`} sx={responsiveStyles}>
      {children}
    </Box>
  );
}
